<div class="row" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table *ngIf="!sppDevice" class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-3">Single Use Device?</th>
                    <th class="col-sm-3">Has a limited number of reuses?</th>
                    <th class="col-sm-3">Maximum Number of Reuses</th>
                    <th class="col-sm-3" *ngIf="applicableRegulation != 'IVDR' && !isSwissdamedIvddDeviceRegulation()">Reprocessed Single Use Device?</th>
                  </tr>
                  <tr>
                    <td>
                      <label controlName="singleUseDevice"> </label> </td>
                    <td>
                      <label controlName="haveLimitedNoReuses"> </label> </td>
                    <td>
                      <label controlName="maxNumberOfReuse"> </label>
                    </td>
                    <td *ngIf="applicableRegulation != 'IVDR' && !isSwissdamedIvddDeviceRegulation()">
                      <label controlName="reprocessedSingleUseDevice"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Packaged or Labeled as Sterile?</th>
                    <th class="col-sm-6">Need Sterilization Before Use?</th>
                  </tr>
                  <tr>
                    <td>
                      <label controlName="packagedOrLabeledAsSterile"></label> </td>
                    <td>
                      <label controlName="needSterilizationBeforeUse"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table *ngIf="applicableRegulation != 'IVDR' && !sppDevice && !isSwissdamedIvddDeviceRegulation()" class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table formArrayName="clinicalSizeTypeForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <!-- Custom grid layout, overriding the Bootsrap grid. The total of 16 columns equals to 100% (6.25% per column vs 12 columns at 8.3333% of the Bootsrap grid)-->
                    <th class="condensed-col-2">Clinical Size Type(s)</th>
                    <th class="condensed-col-2">Size Type Descriptions</th>
                    <th class="condensed-col-1">Language</th>
                    <th class="condensed-col-1">Size Value</th>
                    <th class="condensed-col-1">Range - Min Value</th>
                    <th class="condensed-col-1">Range - Max Value</th>
                    <th class="condensed-col-1">Size Unit</th>
                    <th class="condensed-col-2">Size Unit Descriptions</th>
                    <th class="condensed-col-1">Language</th>
                    <th class="condensed-col-4">Clinical Size Text</th>
                  </tr>
                  <ng-container *ngIf="clinicalSizeTypeForm.controls.length; else emptyTemplate10fields">
                    <tr formGroupName="{{i}}" *ngFor="let sizeGroup of clinicalSizeTypeForm.controls; let i = index">
                      <td>
                        <label controlName="sizeType"></label>
                      </td>
                      <td>
                        <table formArrayName="sizeTypeDescs" class="table table-inner table-condensed table-striped">
                          <tr formGroupName="{{t}}"
                            *ngFor="let type of sizeGroup.get('sizeTypeDescs').controls; let t = index">
                            <td class="no-top-padding-inner-table">
                              <label controlName="value"></label>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td>
                        <table formArrayName="sizeTypeDescs" class="table table-inner table-condensed">
                          <tr formGroupName="{{t}}"
                            *ngFor="let type of sizeGroup.get('sizeTypeDescs').controls; let t = index">
                            <td class="no-top-padding-inner-table">
                              <label controlName="language"></label>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td>
                        <label controlName="sizeValue"></label>
                      </td>
                      <td>
                        <label controlName="sizeMinValue"></label>
                      </td>
                      <td>
                        <label controlName="sizeMaxValue"></label>
                      </td>
                      <td>
                        <label controlName="sizeUnit"></label>
                      </td>
                      <td>
                        <table formArrayName="sizeUnitDescs" class="table table-inner table-condensed">
                          <tr formGroupName="{{t}}"
                            *ngFor="let unit of sizeGroup.get('sizeUnitDescs').controls; let t = index">
                            <td class="no-top-padding-inner-table">
                              <label controlName="value"></label>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td>
                        <table formArrayName="sizeUnitDescs" class="table table-inner table-condensed">
                          <tr formGroupName="{{t}}"
                            *ngFor="let type of sizeGroup.get('sizeUnitDescs').controls; let t = index">
                            <td class="no-top-padding-inner-table">
                              <label controlName="language"></label>
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td>
                        <label controlName="clinicalSizeText"></label>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-left-padding no-right-padding">
              <table formArrayName="storageHandlingForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Storage and Handling Conditions</th>
                    <th class="col-sm-5"><span class="left-padding-8">Storage and Handling Condition Comment</span></th>
                    <th class="col-sm-3"><span class="left-padding-8">Language</span></th>
                  </tr>
                  <ng-container *ngIf="storageHandlingForm.controls.length; else emptyTemplate3fields">
                  <tr formGroupName="{{i}}" *ngFor="let storage of storageHandlingForm.controls; let i = index" >
                    <td>
                      <label controlName="storageHandlingCondition"></label>
                    </td>
                    <td>
                      <table formArrayName="storageHandlingComments" class="table table-inner table-condensed">
                        <tr formGroupName="{{i}}"
                          *ngFor="let comment of storage.get('storageHandlingComments').controls; let i = index">
                          <td class="no-top-padding-inner-table">
                            <label controlName="comments"></label>
                          </td>
                        </tr>
                      </table>
                    </td>

                    <td>
                      <table formArrayName="storageHandlingComments" class="table table-inner table-condensed">
                        <tr formGroupName="{{i}}"
                          *ngFor="let comment of storage.get('storageHandlingComments').controls; let i = index">
                          <td class="no-top-padding-inner-table">
                            <label controlName="languageQualifier"></label>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-condensed"  *ngIf="!sppDevice && applicableRegulation != 'IVDR' && !isSwissdamedLegacyDeviceRegulation() && !isSwissdamedIvddDeviceRegulation()">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th colspan="2">INTENDED PURPOSE OTHER THAN MEDICAL</th>
                  </tr>
                  <tr>
                    <td class="col-sm-6">Intended to be Totally or Partially Introduced into the Human Body?</td>
                    <td class="col-sm-6">
                      <label controlName="intoductedToHumandBody"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Contact Lenses?</td>
                    <td>
                      <label controlName="contactLenses"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Brain Electrostimulation?</td>
                    <td>
                      <label controlName="brainElectroStimulation"></label></td>
                  </tr>
                  <tr>
                    <td>High Intensity Electromagnetic Radiation?</td>
                    <td>
                      <label controlName="highIntencityRadiation"></label></td>
                  </tr>
                  <tr>
                    <td>Equipment to Reduce, Remove or Destroy Adipose Tissue?</td>
                    <td>
                      <label controlName="equipmentToDestroyTissue"></label>
                    </td>
                  </tr>
                  <tr>
                    <td>Intended for Filling by Injection?</td>
                    <td>
                      <label controlName="intendedForInjection"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6"></td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1field>
  <tr>
    <td><label class="label-padding-bottom-15"></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate3fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate4fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate5fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate10fields>
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
